import React from 'react';
import Container from '~/components/Container';
import styles from './CollectionsContent.module.scss';

type Props = {
    data: string;
};

const CollectionsContent = ({ data }: Props) => {
    if (!data) return null;
    return (
        <Container>
            <div className={'blocks'} dangerouslySetInnerHTML={{ __html: data }} />
        </Container>
    );
};

export default CollectionsContent;
